/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import * as React from 'react';

import { IMoeV2ListArrowRightProps } from './moe-v2-list-arrow-right.props.autogenerated';
import { IMoeV2ListArrowRightData } from './moe-v2-list-arrow-right.data';

/**
 * The interface for IMoeV2ListArrowRightViewProps.
 */
export interface IMoeV2ListArrowRightViewProps extends IMoeV2ListArrowRightProps<IMoeV2ListArrowRightData> {}

/**
 *
 * ImageList component.
 * @extends {React.PureComponent<IMoeFileListProps<IMoeFileListData>>}
 */
class MoeV2ListArrowRight extends React.PureComponent<IMoeV2ListArrowRightProps<IMoeV2ListArrowRightData>> {
    public render(): JSX.Element | null {
        return this.props.renderView(this.props);
    }
}

export default MoeV2ListArrowRight;
